<template>
  <div class="addChemical">
    <div class="title">
      危险货物运输安全卡 <span>{{titlename}}安全卡信息</span>
    </div>
    <div class="chemical_info">
      <div class="info_title">{{titlename}}安全卡信息</div>
      <div class="chemical">
        <div class="chemical_list">
          <label for="">
            <span>*</span>化学品名称：
          </label>
          <el-input size="small"
                    v-model="chemicalName"></el-input>
        </div>
        <div class="chemical_list">
          <label for="">
            <span></span>别名：
          </label>
          <el-input size="small"
                    v-model="otherName"></el-input>
        </div>
        <div class="chemical_list">
          <label for="">
            <span>*</span>英文名称：
          </label>
          <el-input size="small"
                    v-model="ENname"></el-input>
        </div>
        <div class="chemical_list">
          <label for="">
            <span></span>化学品分类：
          </label>
          <el-input size="small"
                    v-model="chemicalType"></el-input>
        </div>
        <div class="chemical_list">
          <label for="">
            <span>*</span>危险品类别：
          </label>
          <el-select v-model="hazardous"
                     size="small"
                     @change="handleHazardousClick">
            <el-option v-for="item in hazardousOptions"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="chemical_list typeImg">
          <label for="">
            <span>*</span>类别图标：
          </label>
          <el-input size="small"
                    v-model="iconInfo.imagetype"
                    readonly
                    @focus="handleShowImg"
                    @blur="handleHideImg"></el-input>
          <div class="imgList"
               v-show="imgshow">
            <ul>
              <li v-for="item in iconOptions"
                  :key="item.id"
                  @click="handleSelectImg(item)">
                <img :src="item.imageurl"
                     alt="">
                <p>{{item.imagetype}}</p>
              </li>
            </ul>
          </div>
        </div>
        <div class="chemical_list">
          <label for="">
            <span>*</span>UN编码：
          </label>
          <el-input size="small"
                    v-model="UNnumber"></el-input>
        </div>
        <div class="chemical_list">
          <label for="">
            <span>*</span>CN编码：
          </label>
          <el-input size="small"
                    v-model="CNnumber"></el-input>
        </div>
        <div class="chemical_list">
          <label for="">
            <span>*</span>化学式：
          </label>
          <el-input size="small"
                    v-model="chemicalFormula"></el-input>
        </div>
        <div class="borderLine"></div>
        <div class="textarea_list">
          <label for="">
            <span>*</span>危险性：
          </label>
          <el-input type="textarea"
                    maxlength="1000"
                    rows="3"
                    v-model="dangerVal"></el-input>
          <span class="numberV">{{1000-dangerVal.length}}字</span>
        </div>
        <div class="textarea_list">
          <label for="">
            <span>*</span>泄露处理：
          </label>
          <el-input type="textarea"
                    maxlength="1000"
                    rows="3"
                    v-model="leakVal"></el-input>
          <span class="numberV">{{1000-leakVal.length}}字</span>
        </div>
        <div class="textarea_list">
          <label for="">
            <span>*</span>储运要求：
          </label>
          <el-input type="textarea"
                    maxlength="1000"
                    rows="3"
                    v-model="storeage"></el-input>
          <span class="numberV">{{1000-storeage.length}}字</span>
        </div>
        <div class="textarea_list">
          <label for="">
            <span>*</span>急救：
          </label>
          <el-input type="textarea"
                    maxlength="1000"
                    rows="3"
                    v-model="rescue"></el-input>
          <span class="numberV">{{1000-rescue.length}}字</span>
        </div>
        <div class="textarea_list">
          <label for="">
            <span>*</span>灭火方法：
          </label>
          <el-input type="textarea"
                    maxlength="1000"
                    rows="3"
                    v-model="outfire"></el-input>
          <span class="numberV">{{1000-outfire.length}}字</span>
        </div>
        <div class="textarea_list">
          <label for="">
            <span>*</span>防护措施：
          </label>
          <el-input type="textarea"
                    maxlength="1000"
                    rows="3"
                    v-model="defense"></el-input>
          <span class="numberV">{{1000-defense.length}}字</span>
        </div>
        <div class="textarea_list">
          <label for="">
            <span></span>备注：
          </label>
          <el-input type="textarea"
                    maxlength="1000"
                    rows="3"
                    v-model="remarks"></el-input>
        </div>
        <div class="chemical_list">
          <label></label>
          <el-button @click="handleSaveClick">保存</el-button>
          <el-button @click="handleCancelClick">取消</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getPiclist,
  addSafetyCaed,
  getSafetyCardDetail,
  updateSafetyCard
} from 'apis/index'
export default {
  data () {
    return {
      titlename: '添加',
      id: '',
      createDate: '',
      chemicalName: '', // 化学品名称
      otherName: '', // 别名
      ENname: '', // 英文名
      chemicalType: '', // 化学品类别
      UNnumber: '', // UN编码
      CNnumber: '', // CN编码
      chemicalFormula: '', // 化学式
      imgshow: false,
      imgValue: '',
      dangerVal: '', // 危险性
      leakVal: '', // 泄露处理
      storeage: '', // 储运要求
      rescue: '', // 急救
      outfire: '', // 灭火方法
      defense: '', // 防御措施
      remarks: '', // 备注
      hazardous: '',
      hazardousOptions: [
        {
          value: '一类',
          label: '一类'
        }, {
          value: '二类',
          label: '二类'
        }, {
          value: '三类',
          label: '三类'
        }, {
          value: '四类',
          label: '四类'
        },
        {
          value: '五类',
          label: '五类'
        }, {
          value: '六类',
          label: '六类'
        },
        {
          value: '七类',
          label: '七类'
        }, {
          value: '八类',
          label: '八类'
        },
        {
          value: '九类',
          label: '九类'
        }],
      iconOptions: [],
      iconInfo: {
        imageType: '',
        imgUrl: ''
      }
    }
  },
  methods: {
    getData () {
      getSafetyCardDetail({
        id: this.id
      }).then(res => {
        if (res.data.code === 0) {
          let data = res.data.data
          // console.log('sss', data)
          // console.log(data.typeIcon.imgUrl, data.imageType)
          this.chemicalName = data.chemicalsName
          this.otherName = data.alias
          this.ENname = data.englishName
          this.chemicalType = data.chemicalClassification
          this.hazardous = data.dangerousGoodsCategory
          this.iconInfo.imageurl = data.typeIcon.imgUrl
          this.iconInfo.imagetype = data.imageType
          this.UNnumber = data.unCode
          this.CNnumber = data.cnCode
          this.chemicalFormula = data.chemicalFormula
          this.dangerVal = data.danger
          this.leakVal = data.leakageTreatment
          this.storeage = data.storageTransportationRequirements
          this.rescue = data.firstAid
          this.outfire = data.extinguishingMethod
          this.defense = data.protectiveMeasures
          this.remarks = data.remarks
          this.createDate = data.createDate
          getPiclist({
            type: this.hazardous
          }).then(res => {
            if (res.status === 200) {
              this.iconOptions = res.data.data
              // console.log(res)
            }
          })
        }
      })
    },
    handleBackClick () { // 返回
      this.$router.go(-1)
    },
    handleShowImg () { // 显示隐藏图片
      this.imgshow = true
    },
    handleHideImg () { // 显示隐藏图片
      setTimeout(() => {
        this.imgshow = false
      }, 200)
    },
    handleSelectImg (val) { // 选择图片
      this.iconInfo = val
    },
    handleSaveClick () {
      if (!this.chemicalName | !this.ENname | !this.hazardous | !this.iconInfo.imagetype | !this.UNnumber | !this.CNnumber | !this.chemicalFormula | !this.dangerVal | !this.leakVal | !this.storeage | !this.rescue | !this.outfire | !this.defense) {
        this.$message({
          message: '*为必填内容',
          type: 'warning'
        })
      } else {
        if (this.id) { // 修改
          // console.log('修改')
          // console.log(this.createDate)
          updateSafetyCard({
            id: this.id,
            chemicalsName: this.chemicalName,
            alias: this.otherName,
            englishName: this.ENname,
            chemicalClassification: this.chemicalType,
            dangerousGoodsCategory: this.hazardous,
            'typeIcon.imgUrl': this.iconInfo.imageurl,
            imageType: this.iconInfo.imagetype,
            unCode: this.UNnumber,
            cnCode: this.CNnumber,
            chemicalFormula: this.chemicalFormula,
            danger: this.dangerVal,
            leakageTreatment: this.leakVal,
            storageTransportationRequirements: this.storeage,
            firstAid: this.rescue,
            extinguishingMethod: this.outfire,
            protectiveMeasures: this.defense,
            remarks: this.remarks,
            createDate: this.createDate
          }).then(res => {
            // console.log(res)
            if (res.data.code === 0) {
              this.$router.push({ path: '/manage/chemical' })
            }
          })
        } else { // 添加
          // console.log('添加')
          // console.log(
          //   'chemicalsName:', this.chemicalName,
          //   'alias: ', this.otherName,
          //   'englishName:', this.ENname,
          //   'chemicalClassification:', this.chemicalType,
          //   'dangerousGoodsCategory: ', this.hazardous,
          //   'imgUrl:', this.iconInfo.imageurl,
          //   'imageType:', this.iconInfo.imagetype,
          //   'unCode:', this.UNnumber,
          //   'cnCode:', this.CNnumber,
          //   'chemicalFormula:', this.chemicalFormula,
          //   'danger:', this.dangerVal,
          //   'leakageTreatment:', this.leakVal,
          //   'storageTransportationRequirements:', this.storeage,
          //   'firstAid:', this.rescue,
          //   'extinguishingMethod:', this.outfire,
          //   'protectiveMeasures:', this.defense,
          //   'remarks:', this.remarks
          // )
          addSafetyCaed({
            chemicalsName: this.chemicalName,
            alias: this.otherName,
            englishName: this.ENname,
            chemicalClassification: this.chemicalType,
            dangerousGoodsCategory: this.hazardous,
            'typeIcon.imgUrl': this.iconInfo.imageurl,
            imageType: this.iconInfo.imagetype,
            unCode: this.UNnumber,
            cnCode: this.CNnumber,
            chemicalFormula: this.chemicalFormula,
            danger: this.dangerVal,
            leakageTreatment: this.leakVal,
            storageTransportationRequirements: this.storeage,
            firstAid: this.rescue,
            extinguishingMethod: this.outfire,
            protectiveMeasures: this.defense,
            remarks: this.remarks
          }).then(res => {
            // console.log(res)
            if (res.data.code === 0) {
              this.$router.push({ path: '/manage/chemical' })
            }
          })
        }
      }
    },
    handleCancelClick () {
      this.$router.push({ path: '/manage/chemical' })
    },
    handleHazardousClick () { // 选择类别更换图标
      this.iconInfo = {
        imagetype: '',
        imageurl: ''
      }
      getPiclist({
        type: this.hazardous
      }).then(res => {
        if (res.status === 200) {
          this.iconOptions = res.data.data
          // console.log(res)
        }
      })
    }

  },
  mounted () {
    this.id = this.$route.query.item
    if (this.id) {
      this.getData()
      this.titlename = '修改'
    }
    // console.log(this.id)
  }
}
</script>

<style lang="stylus">
.addChemical
  height 100%
  .title
    padding-left 20px
    height 50px
    line-height 50px
    font-size 12px
    color #858C96
    background url('../../../../assets/images/01/nav_arrow.png') no-repeat top 23px left 137px #F7F9FB
    span
      color #212832
      margin-left 20px
  .chemical_info
    width calc(100% - 40px)
    background #fff
    height calc(100% - 40px)
    overflow auto
    margin 0 auto
    .info_title
      height 46px
      line-height 46px
      padding-left 46px
      color #212832
      background url('../../../../assets/images/gaoji_cheliang.png') no-repeat center left 15px
    .chemical
      padding-top 20px
      overflow hidden
      padding-bottom 10px
      border-top 1px solid #CFD5DC
      color #212832
      .pay_success
        background url('../../../../assets/images/09/success.png') no-repeat center left 85px
      .pay_failed
        background url('../../../../assets/images/09/failure.png') no-repeat center left 85px
      .pay_wait
        background url('../../../../assets/images/09/pay.png') no-repeat center left 85px
      .chemical_list
        width 100%
        height 50px
        label
          display inline-block
          width 168px
          text-align right
          color #5E656F
          span
            color #FF344A
            margin-right 5px
        .el-input
          display inline-block
          color #212832
          width 220px
        .chemical_pay
          color #FF6F12
        .el-button
          background #1B88EE
          padding 6px 24px
          border 1px solid #1B88EE
          color #fff
          margin-right 20px
          span
            width 100%
            color #fff
            font-size 12px
          &:nth-last-child(1)
            background #fff
            padding 6px 24px
            border 1px solid #CFD5DC
            color #1b88ee
            span
              color #1b88ee
      .textarea_list
        width 100%
        height 100px
        label
          display inline-block
          width 168px
          text-align right
          color #5E656F
          height 60px
          span
            color #FF344A
            margin-right 5px
        .el-textarea
          width 562px
        .numberV
          position relative
          top 45px
          left -50px
          color #858C96
          background #fff
      .typeImg
        .el-input--small .el-input__inner
          cursor pointer
          background url('../../../../assets/images/01/arrow_down.png') no-repeat center right 10px
        .imgList
          width 220px
          height 80px
          border 1px solid #ccc
          margin-left 168px
          margin-top 5px
          z-index 99999
          position absolute
          background #fff
          ul
            width 100%
            height 100%
            overflow-y auto
            li
              width 55px
              display inline-block
              cursor pointer
              // float left
              text-align center
              margin 5px
              background #fff
              img
                width 42px
                margin 0 auto
              p
                line-height 20px
      .borderLine
        height 40px
        border-top 1px dashed #ccc
        margin-top 25px
</style>
